<!--
    描述：签署方信息
    日期：2022/06/24
    作者：张卫华
-->
<template>
  <div class="tab-main-page">
    <div class="main-content">
      <el-row>
        <el-col :span="12">
          <span style="font-weight: bold">签署方信息：：</span>
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="12">
          <span style="margin-left: 20px">签署方类型：用户手动签署（个人）/用户手动签署（机构）/  平台方自动签署</span>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <span style="margin-left: 20px">签署方类型说明：</span>
        </el-col>
      </el-row>

      <div class="table-content">
        <el-table ref="xTable"
                  :data="tableObj.data"
                  highlight-current-row
                  :height="tableObj.height"
                  size="mini"
                  border>
          <el-table-column type="index"
                           label="序号"
                           align="center"
                           width="65">
          </el-table-column>
          <el-table-column prop="username"
                           label="用户类型"
                           align="center"
                           min-width="180"
                           show-overflow-tooltip>
          </el-table-column>
          <el-table-column prop="sname"
                           label="platformSign"
                           align="center"
                           min-width="180"
                           show-overflow-tooltip></el-table-column>
          <el-table-column prop="phone"
                           label="signerAccount"
                           align="center"
                           min-width="180"
                           show-overflow-tooltip></el-table-column>
          <el-table-column prop="phone"
                           label="authorizedAccount"
                           align="center"
                           min-width="180"
                           show-overflow-tooltip></el-table-column>
          <el-table-column prop="phone"
                           label="autoExecute"
                           align="center"
                           min-width="180"
                           show-overflow-tooltip></el-table-column>
          <el-table-column prop="phone"
                           label="actorIndentityType"
                           align="center"
                           min-width="180"
                           show-overflow-tooltip></el-table-column>
        </el-table>
      </div>

      <el-row>
        <el-col :span="24">
          <span class="ml20">
            签署顺序：
          </span>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <span class="ml20">
            签署强制阅读时间：10秒
          </span>
        </el-col>
      </el-row>
    </div>
  </div>
</template>
<script>
export default {
  name : 'detail_tab_sti',
  components: {

  },
  data() {
    return {
      tableObj : {
        currentPage: 1, // 当前页码
        pageList: [10, 20, 50, 100], // 显示条数数组
        pageSize: 10, // 当前显示条数
        total: 0, // 当前总条数
        data : [],
        height : '440px'
      },
    }
  },
  mounted() {},
  computed: {},
  // 进入缓存页面
  activated() {

  },
  watch: {},
  created() {},
  methods: {

  }
}
</script>
<style lang="less" scoped>
.tab-main-page{
  .main-content {
    font-family: 'Arial Normal', 'Arial';
    font-weight: 400;
    font-style: normal;
    font-size: 13px;
    color: #333333;
    line-height: normal;

    .el-row {
      padding : 10px 0px;
    }

    .table-content {
      margin-left: 20px;
    }
  }
}
</style>